import AppointmentWlistSuccess from './AppointmentWlistSuccess'

export default AppointmentWlistSuccess